import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Register service worker for offline caching
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registered:', registration.scope);
      })
      .catch((error) => {
        console.log('Service Worker registration failed:', error);
      });
  });
}

const rootEl = document.getElementById("root")!;
// Remove the static prerendered hero placeholder (present in index.html so
// crawlers see the H1 in the raw HTML) before React takes over.
document.getElementById("prerender-hero")?.remove();
createRoot(rootEl).render(<App />);
